import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { UiTagComponent } from '../../atoms/tag/tag.component';
import type { UiTagColor } from '../../atoms/tag/tag.component';
import {
  UiAvatarGroupComponent,
  type UiAvatarGroupParticipant,
} from '../avatar-group/avatar-group.component';

export type { UiTagColor };
export type UiTaskParticipant = UiAvatarGroupParticipant;

export interface UiTaskTag {
  label: string;
  color: UiTagColor;
}

/**
 * Molécula: ítem de tarea o evento en el panel To-Do.
 * Muestra título, rango horario, avatares de participantes, plataforma y tag de categoría.
 * Los participantes se renderizan con la molécula `ui-avatar-group`.
 */
@Component({
  selector: 'ui-task-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiAvatarGroupComponent, UiTagComponent],
  templateUrl: './task-item.component.html',
  styleUrl: './task-item.component.scss',
  host: { class: 'ui-task-item-host' },
})
export class UiTaskItemComponent {
  readonly title = input.required<string>();
  readonly timeRange = input('');
  readonly participants = input<readonly UiTaskParticipant[]>([]);
  readonly maxAvatars = input<number>(3);
  readonly platform = input('');
  readonly tag = input<UiTaskTag | null>(null);

  readonly taskClick = output<void>();
}
